// export const host = 'http://localhost:5000';
export const host = 'https://reca.onrender.com';
export const registerRoute = `${host}/api/auth/register`;
export const loginRoute = `${host}/api/auth/login`;
export const setProfilePictureRoute = `${host}/api/auth/setprofilepicture`;
export const getProfilePictureRoute = `${host}/api/auth/getprofilepicture`;
export const allUsersRoute = `${host}/api/auth/allusers`;
export const sendMessageRoute = `${host}/api/messages/addmessage`;
export const getAllMessagesRoute = `${host}/api/messages/getallmessages`;